import { constants } from 'src/components/player/src/constants/playerConstants';
import { setSessionStorage } from 'src/components/player/src/utils/Utils';
import { createConvivaSessionOnSkip } from 'src/utils/analytics/conviva/ConvivaAnalyticHelper';
import { DynamicObject } from 'src/utils/commonTypes';

import { mixpanelObject } from '../../../../utils/analytics/mixpanel/mixpanel';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_EVENTS_PLAYER_CTAS,
  MIXPANEL_LOGIN,
  MIXPANEL_SKIP
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import { playerCtaEvent } from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../../utils/analytics/mixpanel/mixpanelHelper';
import {
  getLocalStorageInteger,
  getLocalStorage
} from '../../../../utils/browserStorageHandler';
import { gotoLogin, gotoRegister } from '../playerCallbacks';
import { REDIRECT_URL_TO_CONSUMPTION } from 'src/utils/constants/localStorageConstants';

type MandatoryRegistrationPopupProps = {
  playerRef: any;
  closePopUp: any;
};

const MandatoryRegistrationPopup = ({
  playerRef,
  closePopUp
}: MandatoryRegistrationPopupProps) => {
  const { playerConfig = {} } = playerRef || {};
  const { userType = 'guest', tvodState = null } = playerConfig || {};
  let userValue;
  let buyBtnText: string;
  const { messages = {} } = window.translationsAndConfigs || {};

  const userToken = getLocalStorage('token');

  const createSubscribeBlock = () => {
    let subscribeText;

    if (getLocalStorage('entitlementUserType')) {
      userValue = getLocalStorage('entitlementUserType');
    } else {
      userValue = userType;
    }
    switch (userValue) {
      case 'guest':
        subscribeText = messages.Registration_Msg;
        buyBtnText = messages.REGISTER;
        break;
      case 'club':
      case 'RSVOD':
      case 'register':
        subscribeText = messages.CompleteProfile_Msg;
        buyBtnText = messages.CompleteProfile_CTA;
        break;
      default:
        subscribeText = messages.CompleteProfile_Msg;
        buyBtnText = messages.CompleteProfile_CTA;
        break;
    }

    let buyBtnClass = '';
    if (tvodState && tvodState.isComboOfferEnabled) {
      buyBtnClass = `register-button subscribemsg_${messages.localeLanguage} comboRentNow`;
    } else {
      buyBtnClass = `register-button subscribemsg_${messages.localeLanguage}`;
    }
    return (
      <div>
        <div className="subscribe-msg-premium subscribemsg_{messages.localeLanguage}">
          {subscribeText}
        </div>
        <div className={buyBtnClass} onClick={() => buyPlanBtnClick()}>
          {buyBtnText}
        </div>
      </div>
    );
  };
  const createAccountMessage = () => {
    return (
      <div className={`login-msg subscribemsg_${messages.localeLanguage}`}>
        <div className="login_que">{messages.Existing_Users}</div>
      </div>
    );
  };
  const createLoginButton = () => {
    return (
      <div className="login-link-wrap" onClick={() => loginClick()}>
        <span className="userLogin-link">{messages.Login_Button}</span>
      </div>
    );
  };
  const createSkipButton = () => {
    const mandatoryRegistrationPopupCount = getLocalStorageInteger(
      'mandatoryRegistrationPopupCount'
    );
    const { messages = {} } = window.translationsAndConfigs || {};
    if (Object.keys(messages).length) {
      return (
        <div
          className={`skip-button subscribe-link subscribemsg_${messages.localeLanguage}`}
          onClick={() => skipClick(playerRef)}>
          {messages.Player_Skip_UnsubscribedUser_Text}
        </div>
      );
    }
  };

  const loginClick = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    closePopUp();
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_LOGIN;
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
    playerCtaEvent();
    gotoLogin();
  };

  const buyPlanBtnClick = () => {
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    closePopUp();
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] = buyBtnText;
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
    playerCtaEvent();
    gotoRegister();
  };

  const skipClick = (playerRef: DynamicObject) => {
    closePopUp();
    createConvivaSessionOnSkip(playerRef);
    const {
      singlePlayDetails = {},
      playerConfig = {},
      playableData = {},
      mixpanelData = {},
      videoPlayer
    } = playerRef || {};
    const { userData: { user = {} } = {} } = playerConfig || {};
    const configJson = {
      analyticData: playableData,
      singlePlayData: singlePlayDetails,
      mixpanelDetail: mixpanelData,
      user
    };
    let mixpanelJsonData = null;
    if (window && window.analyticsManager) {
      mixpanelJsonData = window.analyticsManager.jsonInitilize(
        configJson,
        videoPlayer
      );
    }
    window.analyticsManager.setMixpanelData(mixpanelJsonData);
    clearCtaEventsProperty(mixpanelObject);
    mixpanelObject[MIXPANEL_ELEMENT] = MIXPANEL_SKIP;
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = MIXPANEL_EVENTS_PLAYER_CTAS;
    playerCtaEvent();
    videoPlayer.play();
  };
  return (
    <div className="main-Inner-container">
      <div className="section-container main-container-1">
        {createSubscribeBlock()}
        {createSkipButton()}
      </div>
      {(userToken === '' || userToken === undefined || userToken == null) && (
        <div className="section-container main-container-2">
          {createAccountMessage()}
          {createLoginButton()}
        </div>
      )}
    </div>
  );
};

export default MandatoryRegistrationPopup;
